import { request, requestPublic } from "./request.js";

// 更新文章索引
export function UpdateArticleIndex(data) {
  return request({
    url: "/api2/ZsbSiteWeb/ElasticSearch/UpdateArticleIndex",
    method: "post",
    data: data,
  });
}

// 更新非普本专业索引
export function UpdateMajorIndex(data) {
  return request({
    url: "/api2/ZsbSiteWeb/ElasticSearch/UpdateMajorIndex",
    method: "post",
    data: data,
  });
}

// 更新非普本院校索引
export function UpdateSchoolIndex(data) {
  return request({
    url: "/api2/ZsbSiteWeb/ElasticSearch/UpdateSchoolIndex",
    method: "post",
    data: data,
  });
}

// 更新普本院校和专业索引
export function UpdateSchoolAndMajorIndex(data) {
  return request({
    url: "/api2/ZsbSiteWeb/ElasticSearch/UpdatePtSchoolAndMajorIndex",
    method: "post",
    data: data,
  });
}

// 发布成考专升本-手机端
export function PublishCkzsbHtmlMobile(data) {
  return request({
    url: "/api2/ZsbSiteAdmin/HtmlRelease/PublishCkzsbHtmlMobile",
    method: "post",
    data: data,
  });
}

// 发布开放教育-手机端
export function PublishWlycjyHtmlMobile(data) {
  return request({
    url: "/api2/ZsbSiteAdmin/HtmlRelease/PublishWlycjyHtmlMobile",
    method: "post",
    data: data,
  });
}

// 发布首页--PC端
export function PublishHome(data) {
  return request({
    url: "/api2/ZsbSiteAdmin/HtmlRelease/PublishHome",
    method: "post",
    data: data,
  });
}

// 发布普通专升本--PC端
export function CreatePtzsbCategoryHtml(data) {
  return request({
    url: "/api2/ZsbSiteAdmin/HtmlRelease/CreatePtzsbCategoryHtml",
    method: "post",
    data: data,
  });
}

// 发布自考专升本--PC端
export function CreateZkzsbCategoryHtml(data) {
  return request({
    url: "/api2/ZsbSiteAdmin/HtmlRelease/CreateZkzsbCategoryHtml",
    method: "post",
    data: data,
  });
}

// 发布成考专升本--PC端
export function CreateCkzsbCategoryHtml(data) {
  return request({
    url: "/api2/ZsbSiteAdmin/HtmlRelease/CreateCkzsbCategoryHtml",
    method: "post",
    data: data,
  });
}

// 发布开放教育--PC端
export function CreateWlycjyCategoryHtml(data) {
  return request({
    url: "/api2/ZsbSiteAdmin/HtmlRelease/CreateWlycjyCategoryHtml",
    method: "post",
    data: data,
  });
}